export default "__VITE_ASSET__404554e0__"